import { apiAxios } from "../../apiConfig";

export const getVoters = async () => {
  try {
    const response = await apiAxios.get("/voters?limit=1000");

    return response.data;
  } catch (error) {
    console.error("Error fetching voters:", error);
    throw error;
  }
};

export const getVoteInfoBoxes = async () => {
  try {
    const response = await apiAxios.get("/vote-info");

    return response.data;
  } catch (error) {
    console.error("Error fetching vote info boxes:", error);
    throw error;
  }
};

export const createVoteInfoBox = async (payload) => {
  try {
    const response = await apiAxios.post("/vote-info", payload);

    return response.data;
  } catch (error) {
    console.error("Error creating vote info box:", error);
    throw error;
  }
};

export const updateVoteInfoBox = async (boxId, payload) => {
  try {
    const response = await apiAxios.put(`/vote-info/${boxId}`, payload);

    return response.data;
  } catch (error) {
    console.error("Error updating vote info box:", error);
    throw error;
  }
};

export const deleteVoteInfoBox = async (boxId) => {
  try {
    const response = await apiAxios.delete(`/vote-info/${boxId}`);

    return response.data;
  } catch (error) {
    console.error("Error deleting vote info box:", error);
    throw error;
  }
};
